  
/*
 *  Recently Viewed
 *    Scripts for recently viewed snippet
 *
 *  Dependencies:
 *    jQuery - jQuery is required for selectors.
 *    js-cookie (Optional) - Required for reading/writing cookies
 *    jQuery Cookie (Optional) - Same as JS cookie, however one of the two IS required
 *
 *  Settings:
 *    RecentlyViewed.maxHistory - Max history of products to track (Defaults to 8)
 *
 *  Version:
 *    1.0.0 - 2020/08/13
 */


import $ from 'jquery';
import Cookies from 'js-cookie';
import { CarouselSection } from '../carousel/CarouselSection';
import * as ResponsiveSizes from '../../settings/Responsive';
import { ProductThumbnailPrint } from '../../objects/product/ProductThumbnailPrint';
import { register } from '../ShopifySection';
import { mainUpdateCSS } from './../../tools/SetHeaderHeight';

export const MAX_HISTORY = 15;

export const SELECTOR_VIEW = '[data-product-view]'
export const CONTAINER_SELECTOR = '[data-recently-viewed-container]';
export const CAROUSEL_SELECTOR = '[data-recently-viewed]';
export const ATTR_VIEW_ID = 'data-product-view-id';
export const ATTR_VIEW_CURRENT = 'data-recently-viewed-current';
export const CLASS_CAROUSEL = '.is-carousel';


export const CLASS_VISIBLE = 'is-visible';


$(window).on('resize orientationchange', (e) => mainUpdateCSS('[data-header-container]'));

//Utility functions
export const getViewedIDs = () => {
  let existing = Cookies.getJSON('recent-product-views');
  return existing && existing.length ? existing : [];
}

export const registerView = (id) => {

  let existing = getViewedIDs();
  if(existing.indexOf(id) !== -1) return;//This is already in the recently viewed

  existing = [ id, ...existing ];
  existing = existing.splice(0, MAX_HISTORY);
  //JS Cookies
  Cookies.set("recent-product-views", JSON.stringify(existing), { path:'/', expires:21 });
}

//Stores the pending (or finished) promise for fetching data
let fetchingDataPromise = null;

//Fetch view
export const fetchRecentlyViewed = () => {
  if(fetchingDataPromise) return fetchingDataPromise;
  let q = getViewedIDs().map(id => `id:${id}`).join(' OR ');
  return fetchingDataPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: '/search',
      method: "GET",
      data: { 'view': 'json-product', q },
      success: data => {
        //Try parse the data as JSON
        try {
          data = JSON.parse(data);
          resolve(data);
        } catch(ex) {
          return reject(ex);
        }
      },
      error: (jqXHR,status,error) => reject(error)
    });
  });
}



//Section Class - This is where we are going to print the products in section
export class RecentlyViewed extends CarouselSection {
  //Class
  constructor(container) {
    super(container);
    this.container = container;

    this.recentlyViewedProducts = container.find(CAROUSEL_SELECTOR);
    this.currentProductId = this.recentlyViewedProducts.attr(ATTR_VIEW_CURRENT);
    this.isCarousel = container.find(CLASS_CAROUSEL);

    if (this.recentlyViewedProduct) {
      fetchRecentlyViewed()
      .then(e => this.onRecentlyViewedFetched(e))
      .catch(ex => this.onRecentlyViewedError(ex));
    }
  }

  onRecentlyViewedFetched(e) {

    if(e.length < 1) return; //Nothing related to display.

    this.container.addClass(CLASS_VISIBLE); //We have products, show the container.

    onRecentlyViewedMenuImageonHover(e);

    let productPrint = e.reduce((x,p) => {
      let url = p.url;

      let available = false;
      let v = p.variants[0];

      p.variants.forEach((variant) => {
        if(variant.available) available = true;
      });

      let p2 = {...p};//Duplicate
      p2.variants = p2.variants.map(variant => {
        let v2 = {...variant};//Duplicate
        delete v2.product;//Remove circular reference
        return v2;
      });

      //Check if product has a discounted price.
      let discounted = false;
      let saving = 0;
      let compare = v.compare_at_price;
      if(compare > v.price) {
        discounted = true;
        saving = 1 - v.price / compare;
        saving = saving * 100; //convert to percentage
      }

      return x += ProductThumbnailPrint(p, p2, url, discounted, saving, available, compare, v);

    }, '');

    this.recentlyViewedProducts.html(productPrint);
    if(this.isCarousel != undefined && (this.isCarousel).length > 0) {
      this.initCarousel(this.recentlyViewedProducts);
    }

  }


  onRecentlyViewedError(ex) {
    console.error(`Failed to fetch recently viewed!`);
    console.error(ex);
  }

  optionOverrides() {
    return {
      centerMode: true,
      waitForAnimate: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 2, slidesToScroll: 1 }
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: { slidesToShow: 3, slidesToScroll: 1, arrows: true }
        },
        {
          breakpoint: ResponsiveSizes.large-1,
          settings: { slidesToShow: 4, slidesToScroll: 1, arrows: true }
        },
        {
          breakpoint: ResponsiveSizes.xlarge-1,
          settings: { slidesToShow: 5, slidesToScroll: 1, arrows: true }
        }
      ]
    }
  }
}

register(CONTAINER_SELECTOR, RecentlyViewed);


//Register views as they occur
$(document).ready(() => {
  //Store view if any
  let id = $(SELECTOR_VIEW).attr(ATTR_VIEW_ID)
  if(id && id.length) registerView(id);
});
